<template>
  <formsTemplate>
    <v-form ref="form" v-model="valid" lazy-validation>
      <p class="font-weight-bold text-body-1 text-center mb-10">
        {{ $t("registerView.doRegister") }}
      </p>
      <p class="font-weight-bold text-body-1">{{ $t("registerView.name") }}</p>
      <v-text-field
        solo
        v-model="name"
        hide-details="auto"
        :rules="[rules.required]"
        @keydown.enter="logar"
        flat
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
      </v-text-field>
      <p class="font-weight-bold text-body-1 mt-6">
        {{ $t("registerView.email") }}
      </p>
      <v-text-field
        solo
        v-model="email"
        hide-details="auto"
        :rules="[rules.required, rules.email]"
        @keydown.enter="logar"
        flat
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
      </v-text-field>
      <p class="font-weight-bold text-body-1 mt-6">
        {{ $t("registerView.password") }}
      </p>
      <!-- FIX rules.password] -->
      <v-text-field
        v-model="senha"
        solo
        hide-details="auto"
        :rules="[rules.required, rules.password]"
        autocomplete="new-password"
        flat
        @keydown.enter="logar"
        :type="show ? 'text' : 'password'"
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
        <template slot="append">
          <a @click="show = !show">
            <v-icon>{{ show ? "$eye-off" : "$eye" }}</v-icon>
          </a>
        </template>
      </v-text-field>
      <div class="d-flex justify-space-between mt-6">
        <v-btn
          color="secondary"
          class="primary--text"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :to="{ name: 'login', query: $route.query }"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("registerView.textLogin") }}
          </p>
        </v-btn>
        <v-btn
          color="success"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :loading="loading"
          @click="registrar"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("registerView.account") }}
          </p>
        </v-btn>
      </div>
    </v-form>
  </formsTemplate>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { rules } from "@/mixins/rules";
import formsTemplate from "@/components/formsTemplate.vue";
export default {
  components: {
    formsTemplate,
  },
  data: () => ({
    show: false,
    name: "",
    email: "",
    senha: "",

    rules,
    valid: false,
  }),
  computed: {
    ...mapState(useAuthStore, ["loading"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["register"]),

    async registrar() {
      await this.$refs.form.validate();
      if (this.valid) this.register(this.name, this.email, this.senha);
    },
  },
};
</script>
<style scoped>
.m-auto {
  margin-left: auto;
  margin-right: auto;
}
::v-deep .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #252831;
}
</style>
